import { Injectable, TemplateRef } from '@angular/core';

@Injectable()
export class MetadataTemplateManagerService {
  private templates: Map<string,TemplateRef<any>> = new Map<string,TemplateRef<any>>();

  constructor() { }

  public registerTemplate(key: string, template: TemplateRef<any>)  {
    this.templates.set(key, template);
  }

  public getTemplate(key: string): TemplateRef<any>{
    return this.templates.get(key);
  }

  public hasKey(key: string): boolean {
    return this.templates.has(key);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/workspace/services/metadata-template-manager.service.ts